module.exports = __webpack_public_path__ + "./images/roller.jpg?c0084be37841e7697747f9992847d937";


//////////////////
// WEBPACK FOOTER
// ./src/assets/roller.jpg
// module id = 42
// module chunks = 0